import i18next from 'i18next';
import { CboRole } from '@cbo/shared-library';
import isPermitted from '../../../lib/permissions';
import { useUsers } from '../../../contexts/userContext';
import routes from '../../../constants/routes';
import { NavItem } from '.';

export default function useAccountRoutes(): NavItem[] {
  const user = useUsers();

  const accountRoutes: NavItem[] = [];

  if (isPermitted(user, [CboRole.MANAGED_EMPLOYEE_GRANT, CboRole.EMPLOYEE_PERSONAL_EDIT], true)) {
    accountRoutes.push({
      title: i18next.t('navItems.myInformation'),
      href: routes.EMPLOYEE_REGISTRATION_HOME,
      testid: 'employee-registration-module',
    });
  }

  return accountRoutes;
}
